var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn-toggle',{staticClass:"test-toggle-component",attrs:{"dense":"","rounded":"","outlined":""},on:{"change":function($event){return _vm.switchResult($event)}}},_vm._l((_vm.buttons),function(btn,index){return _c('v-btn',{key:btn.status || index,class:_vm.isSelect == index
        ? 'btn-selected text-subtitle-2 '
        : 'btn-default text-subtitle-2',attrs:{"width":"100px","outlined":"","disabled":btn.disable}},[_vm._v(" "+_vm._s(btn.status)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }